import { IParentService } from "../types/IParentService";
import { ServiceType } from "../types/ServiceType";

export const IdwalServices: IParentService[] = [
    {
        name: "Jira Orchestration",
        id: "jira-orchestration",
        icon: "/images/jira-icon.png",
        type: ServiceType.JIRA,
        services: [
            {
                name: "jira-quotation-modify",
                parentName: "Jira Orchestration",
                parentId: "jira-orchestration"
            },
            {
                name: "jira-quotation-cancel",
                parentName: "Jira Orchestration",
                parentId: "jira-orchestration"
            },
            {
                name: "jira-quotation-created",
                parentName: "Jira Orchestration",
                parentId: "jira-orchestration"
            },
            {
                name: "jira-inspection-modify",
                parentName: "Jira Orchestration",
                parentId: "jira-orchestration"
            },
            {
                name: "jira-inspection-complete",
                parentName: "Jira Orchestration",
                parentId: "jira-orchestration"
            },
            {
                name: "jira-inspection-cancel",
                parentName: "Jira Orchestration",
                parentId: "jira-orchestration"
            },
            {
                name: "jira-inspection-created",
                parentName: "Jira Orchestration",
                parentId: "jira-orchestration"
            },
            {
                name: "jira-inspection-section-complete",
                parentName: "Jira Orchestration",
                parentId: "jira-orchestration"
            },
            {
                name: "jira-comment-handler",
                parentName: "Jira Orchestration",
                parentId: "jira-orchestration"
            }  
        ]
    },
    {
        name: "Idwal External API",
        id: "idwal-external-api",
        icon: "/images/external-api-icon.png",
        type: ServiceType.IDWAL_EXTERNAL_API,
        services: [
            {
                name: "grade",
                parentName: "Idwal External API",
                parentId: "idwal-external-api"
            },
            {
                name: "grade-basic",
                parentName: "Idwal External API",
                parentId: "idwal-external-api"
            },
            {
                name: "grade-full",
                parentName: "Idwal External API",
                parentId: "idwal-external-api"
            },
            {
                name: "broker-basic",
                parentName: "Idwal External API",
                parentId: "idwal-external-api"
            },
            {
                name: "broker-full",
                parentName: "Idwal External API",
                parentId: "idwal-external-api"
            },
            {
                name: "broker-grade",
                parentName: "Idwal External API",
                parentId: "idwal-external-api"
            },
            {
                name: "sedna",
                parentName: "Idwal External API",
                parentId: "idwal-external-api"
            },
            {
                name: "modelling-model1",
                parentName: "Idwal External API",
                parentId: "idwal-external-api"
            },
            {
                name: "modelling-model2",
                parentName: "Idwal External API",
                parentId: "idwal-external-api"
            },
            {
                name: "screening-snapshot",
                parentName: "Idwal External API",
                parentId: "idwal-external-api"
            }
        ]
    },
    {
        name: "Hubspot Orchestration",
        id: "hubspot-orchestration",
        icon: "/images/hubspot-icon.jpeg",
        type: ServiceType.HUBSPOT,
        services: [
            {
                name: "hubspot-create-customer",
                parentName: "Hubspot Orchestration",
                parentId: "hubspot-orchestration"
            },
            {
                name: "hubspot-deal-management",
                parentName: "Hubspot Orchestration",
                parentId: "hubspot-orchestration"
            },
            {
                name: "cancelled-deal",
                parentName: "Hubspot Orchestration",
                parentId: "hubspot-orchestration"
            }
        ]
    },
    {
        name: "Idwal Invoicing",
        id: "invoicing-orchestration",
        icon: "/images/aqilla-icon.png",
        type: ServiceType.INVOICING,
        services: [
            {
                name: "invoice-raiser",
                parentName: "Idwal Invoicing",
                parentId: "invoicing-orchestration"
            }
        ]
    },
    {
        name: "Fleet Performance",
        id: "fleet-performance",
        icon: "",
        type: ServiceType.FLEET_PERFORMANCE,
        services: []
    },
];
